import builder from '../builder';
import MessagesBubbleArrow2 from '../../streamline-icons/light/messages-bubble-arrow-2.svg';

export default builder('IconMessagesBubbleArrow2Light', MessagesBubbleArrow2);
